const baseURL = "/v1/Usuario";

const service = {
  methods: {
    $buscarUsuario(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $visualizarUsuario({ params, id }) {
      return this.$api().get(`${baseURL}/${id}`, params);
    },
    $cadastrarUsuario(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editarUsuario(body, id) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $inativarAtivarUsuario(body, id) {
      return this.$api().patch(`${baseURL}/AlterarStatus/${id}`, body);
    },
    $trocarSenha(body) {
      return this.$api().post(`${baseURL}/MudarSenha`, body);
    },
    $obterPerfisDoUsuario({ params, id }) {
      return this.$api().get(`${baseURL}/${id}/Perfis`, params);
    },    
    $detalharUsoUsuario({ id, params}) {
      return this.$api().get(`${baseURL}/DetalharUso/${id}`, params);
    },
  },
};

export default service;
